<template>
    <div :class="{ 'pb-5': ! slim }">
        <label class="block text-sm font-medium text-gray-700 mb-2" v-if="label">
            {{ label }} 
            <span v-if="optional">({{ __('forms::labels.optional').toLowerCase() }})</span>
        </label>
        <slot></slot>
        <FormError :message="error" />
    </div>
</template>

<script>
    export default {
        props: {
            label: {
                type: String,
                default: '',
            },
            error: {
                type: String,
                default: null,
            },
            slim: {
                type: Boolean,
                default: false,
            },
            optional: {
                type: Boolean,
                default: false,
            },
        },
    }
</script>